import { render, staticRenderFns } from "./MenubarProfile.vue?vue&type=template&id=45cf5b62&"
import script from "./MenubarProfile.vue?vue&type=script&lang=js&"
export * from "./MenubarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports